import User from '@/api/user'
import { setToken, getToken, removeToken } from '@/libs/utils'
export default {
	namespaced: true,
	state: {
		userName: '',
		userId: '',
		avatorImgPath: '',
		token: getToken(),
		access: '',
		hasGetInfo: false,
		userInfo: {}
	},
	mutations: {
		setUserId(state, id) {
			state.userId = id
		},
		setUserName(state, name) {
			state.userName = name
		},
		setAccess(state, access) {
			state.access = access
		},
		setToken(state, { access_token, expires_in }) {
			state.token = access_token
			setToken(access_token, expires_in)
		},
		setHasGetInfo(state, status) {
			state.hasGetInfo = status
		},
		setUserInfo(state, userInfo) {
			let { age } = userInfo

			state.userInfo = { ...userInfo, age: age === 0 ? '' : age }
		}
	},
	getters: {},
	actions: {
		setUserToken({ commit }, param) {
			commit('setToken', param)
		},
		getUserInfo({ commit }) {
			return new Promise((resolve, reject) => {
				try {
					User.getUserInfo()
						.then((res) => {
							const data = res.result
							// commit("setAvator", data.avator)
							// commit("setUserName", data.data.name)
							// commit("setUserId", data.data.id)
							commit('setUserInfo', data.data)
							resolve(data)
						})
						.catch((err) => {
							reject(err)
						})
				} catch (error) {
					reject(error)
				}
			})
		},
		handleLogOut() {
			return new Promise((resolve, reject) => {
				User.logout()
					.then((res) => {
						removeToken()
						resolve(res)
					})
					.catch((err) => {
						reject(err)
					})
			})
		}
	}
}
